/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  GenerationCompleteDto,
  MarkAllNotificationsAsRead200Response,
  MarkNotificationAsRead200Response,
  NotificationListResponseDto,
  UnreadCountResponseDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GenerationCompleteDtoFromJSON,
    GenerationCompleteDtoToJSON,
    MarkAllNotificationsAsRead200ResponseFromJSON,
    MarkAllNotificationsAsRead200ResponseToJSON,
    MarkNotificationAsRead200ResponseFromJSON,
    MarkNotificationAsRead200ResponseToJSON,
    NotificationListResponseDtoFromJSON,
    NotificationListResponseDtoToJSON,
    UnreadCountResponseDtoFromJSON,
    UnreadCountResponseDtoToJSON,
} from '../models/index';

export interface GetNotificationsRequest {
    pageSize: number;
    page?: number;
    nextPageToken?: string;
    isRead?: boolean;
}

export interface MarkNotificationAsReadRequest {
    id: string;
}

export interface OnGenerationCompleteRequest {
    generationCompleteDto: GenerationCompleteDto;
}

/**
 * 
 */
export class NotificationsApi extends runtime.BaseAPI {

    /**
     * Get the count of unread notifications for the authenticated patient
     * Get unread notification count
     */
    async getNotificationUnreadCountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnreadCountResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/notifications/unread-count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnreadCountResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get the count of unread notifications for the authenticated patient
     * Get unread notification count
     */
    async getNotificationUnreadCount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnreadCountResponseDto> {
        const response = await this.getNotificationUnreadCountRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get paginated list of notifications for the authenticated patient
     * Get notification inbox
     */
    async getNotificationsRaw(requestParameters: GetNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationListResponseDto>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling getNotifications().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['nextPageToken'] != null) {
            queryParameters['nextPageToken'] = requestParameters['nextPageToken'];
        }

        if (requestParameters['isRead'] != null) {
            queryParameters['isRead'] = requestParameters['isRead'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/notifications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get paginated list of notifications for the authenticated patient
     * Get notification inbox
     */
    async getNotifications(requestParameters: GetNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationListResponseDto> {
        const response = await this.getNotificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark all unread notifications as read for the authenticated patient
     * Mark all notifications as read
     */
    async markAllNotificationsAsReadRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarkAllNotificationsAsRead200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/notifications/read-all`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MarkAllNotificationsAsRead200ResponseFromJSON(jsonValue));
    }

    /**
     * Mark all unread notifications as read for the authenticated patient
     * Mark all notifications as read
     */
    async markAllNotificationsAsRead(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarkAllNotificationsAsRead200Response> {
        const response = await this.markAllNotificationsAsReadRaw(initOverrides);
        return await response.value();
    }

    /**
     * Mark a single notification as read by ID
     * Mark notification as read
     */
    async markNotificationAsReadRaw(requestParameters: MarkNotificationAsReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarkNotificationAsRead200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling markNotificationAsRead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/notifications/{id}/read`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MarkNotificationAsRead200ResponseFromJSON(jsonValue));
    }

    /**
     * Mark a single notification as read by ID
     * Mark notification as read
     */
    async markNotificationAsRead(requestParameters: MarkNotificationAsReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarkNotificationAsRead200Response> {
        const response = await this.markNotificationAsReadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Webhook for Cloud Functions to call when treatment plan or instruction generation completes
     * Notify generation complete
     */
    async onGenerationCompleteRaw(requestParameters: OnGenerationCompleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['generationCompleteDto'] == null) {
            throw new runtime.RequiredError(
                'generationCompleteDto',
                'Required parameter "generationCompleteDto" was null or undefined when calling onGenerationComplete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key authentication
        }

        const response = await this.request({
            path: `/notifications/generation-complete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GenerationCompleteDtoToJSON(requestParameters['generationCompleteDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Webhook for Cloud Functions to call when treatment plan or instruction generation completes
     * Notify generation complete
     */
    async onGenerationComplete(requestParameters: OnGenerationCompleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.onGenerationCompleteRaw(requestParameters, initOverrides);
    }

}
